import React from 'react';

import { Container, Dot, Item } from './DataTableThreatLegend.style';
import { IDataTableSettingsThreatLimit } from './types';

interface DataTableThreatLegendProps {
    fontSize: number;
    threatLimits?: IDataTableSettingsThreatLimit[];
}

const DataTableThreatLegend: React.FC<DataTableThreatLegendProps> = ({ threatLimits, fontSize }) => {
    if (!threatLimits) {
        return null;
    }

    return (
        <Container fontSize={fontSize}>
            {threatLimits.length > 0 && <Item>Risk Level:</Item>}
            {threatLimits.map(({ id, backgroundColor, label }) => (
                <Item key={id}>
                    <Dot backgroundColor={backgroundColor} />
                    {label}
                </Item>
            ))}
        </Container>
    );
};

export default DataTableThreatLegend;
